import http from '@/communication/AuthConnection'

export default ({_id, idx, name}) => {
  return http.put(`/v1/occupation/${_id}`, {name})
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/occupation/EditOccupation.js